import {observer} from "mobx-react";
import * as React from "react";
import {QuizQuestion} from "components/quiz/QuizQuestion";
import {UserAnswer} from "components/quiz/UserAnswer";


interface ITextQuestion_Props {
  userAnswer:UserAnswer;
}

@observer
export class TextQuestion extends React.Component<ITextQuestion_Props> {

  handleChange = (e:any) => {
    this.props.userAnswer.answerValue = e.target.value;
  }

  render() {
    return (
      <QuizQuestion>
        <textarea style={{width: '99%', height: '60px'}} value={this.props.userAnswer.answerValue} onChange={this.handleChange}></textarea>
      </QuizQuestion>
    );
  }


}
